import { createSlice } from "@reduxjs/toolkit";

const loadInitialState = () => {
    try {
        const savedCart = localStorage.getItem('cart');
        return savedCart ? { items: JSON.parse(savedCart) } : { items: [] };
    } catch (error) {
        console.error('Error loading cart from localStorage:', error);
        return { items: [] };
    }
};

const cartSlice = createSlice({
    name: "cart",
    initialState: loadInitialState(),
    reducers: {
        addToCart: (state, action) => {
            const item = action.payload;
            if (!item || !item.id) {
                console.error('Invalid item data:', item);
                return;
            }

            const existingItem = state.items.find(cartItem => cartItem.id === item.id);
            
            if (existingItem) {
                existingItem.quantity = (existingItem.quantity || 0) + (item.quantity || 1);
                console.log(`Updated quantity for item ID: ${item.id}, New Quantity: ${existingItem.quantity}`);
            } else {
                state.items.push({
                    ...item,
                    quantity: item.quantity || 1
                });
                console.log(`Added new item to cart:`, item);
            }
            
            try {
                localStorage.setItem('cart', JSON.stringify(state.items));
            } catch (error) {
                console.error('Error saving cart to localStorage:', error);
            }
        },
        removeFromCart: (state, action) => {
            const { itemId } = action.payload;
            state.items = state.items.filter(item => item.id !== itemId);
            console.log(`Removed item with ID: ${itemId}`);
            
            try {
                localStorage.setItem('cart', JSON.stringify(state.items));
            } catch (error) {
                console.error('Error saving cart to localStorage:', error);
            }
        },
        updateQuantity: (state, action) => {
            const { itemId, quantity } = action.payload;
            const item = state.items.find(cartItem => cartItem.id === itemId);
            
            if (item) {
                item.quantity = quantity;
                console.log(`Updated item ID: ${itemId}, New Quantity: ${quantity}`);
                
                if (item.quantity <= 0) {
                    state.items = state.items.filter(cartItem => cartItem.id !== itemId);
                    console.log(`Removed item with ID: ${itemId} because quantity is zero`);
                }
                
                try {
                    localStorage.setItem('cart', JSON.stringify(state.items));
                } catch (error) {
                    console.error('Error saving cart to localStorage:', error);
                }
            }
        },
        clearCart: (state) => {
            state.items = [];
            console.log(`Cart cleared`);
            try {
                localStorage.removeItem('cart');
            } catch (error) {
                console.error('Error clearing cart from localStorage:', error);
            }
        }
    }
});

export const {
    addToCart,
    removeFromCart,
    updateQuantity,
    clearCart
} = cartSlice.actions;

export default cartSlice.reducer;